import React from "react";
import {
  Container,
  SpaceBetween,
  Box,
  ColumnLayout,
} from "@amzn/awsui-components-react";

export const Migration = () => {
  return (
    <div className="migration-page" style={{ padding: "40px 20px" }}>
      <div style={{ maxWidth: "800px", margin: "0 auto" }}>
        <Container>
          <SpaceBetween size="l">
            <Box variant="h1" fontWeight="heavy">
              AWS Partner Central in the AWS Console
            </Box>

            <ColumnLayout columns={1} variant="text-grid">
              <div>
                <Box variant="awsui-key-label">Description</Box>
                <div>
                  Migrate to AWS Partner Central in the AWS Management Console to access your funding benefits. Review the{" "}
                  <a href="https://partnercentral.awspartner.com/partnercentral2/s/article?category=Introductory_resources&article=Partner-Central-Migration-Guide" target="_blank" rel="noopener noreferrer">
                    Migration Guide
                  </a>{" "}
                  for step-by-step instructions.
                </div>
              </div>
            </ColumnLayout>
          </SpaceBetween>
        </Container>
      </div>
    </div>
  );
};

export default Migration;
